export const INIT = "INIT";
export const LOADING = "LOADING";
export const ERRORING = "ERRORING";
export const SELECT_SHIPS = "SELECT_SHIPS";
export const ALL_CLEAR = "ALL_CLEAR";
